import {
  deleteAlbaranArichivoAdjunto,
  getAlbaranDocsAsociadosById,
  getAlbaranesDocumentoPendienteValidacionDocumentoPendienteValidacion,
  getAlbaranFicherosAdjuntosId,
  getAlbaranPdfById,
  postAlbaranAñadirArchivoAdjunto,
} from "api/Albaran.service"
import { FicheroCreationDtoProps } from "api/DTOs/FicheroCreationDto"
import {
  deleteFacturaArichivoAdjunto,
  getFacturaDocsAsociadosById,
  getFacturaFicherosAdjuntosId,
  getFacturaPdfById,
  getFacturasDocumentoPendienteValidacionDocumentoPendienteValidacion,
  postFacturaAñadirArchivoAdjunto,
} from "api/Factura.service"
import {
  deletePedidoArichivoAdjunto,
  getPedidoDocsAsociadosById,
  getPedidoDocumentoPendienteValidacionDocumentoPendienteValidacion,
  getPedidoFicherosAdjuntosId,
  getPedidoPdfById,
  postPedidoAñadirArchivoAdjunto,
} from "api/Pedido.service"
import {
  deletePresupuestoArichivoAdjunto,
  getPresupuestoDocsAsociadosById,
  getPresupuestoDocumentoPendienteValidacionDocumentoPendienteValidacion,
  getPresupuestoFicherosAdjuntosId,
  getPresupuestoPdfById,
  postPresupuestoAñadirArchivoAdjunto,
} from "api/Presupuesto.service"
import {
  TIPO_DOCUMENTO_ENUM,
  TipoDocumentoEnumType,
} from "api/Types/TipoDocumentoEnum"
import { formatCurrency } from "common/utils/currency"

export const TAB_OPTIONS = (t: $TSMigrationFixMe) => {
  return {
    1: {
      label: `${t("crear.presupuesto.modal.docLabel")}`,
      value: 1,
    },
    2: {
      label: `${t("crear.presupuesto.modal.flujoLabel")}`,
      value: 2,
    },
  }
}

export const STATUSCORRECT = 200

export const TYPES_DOC = {
  PRESUPUESTO: 25,
  PEDIDO: 24,
  ALBARAN: 18,
  FACTURA: 2,
  COMPRA: 0,
  VENTA: 1,
}

export const getSumOfImportes = (items: $TSMigrationFixMe) => {
  const sum = items.reduce(
    (accumulator: $TSMigrationFixMe, currentItem: $TSMigrationFixMe) => {
      return accumulator + currentItem.importe
    },
    0
  )

  return sum
}
export const COLUMNAS_ADD_PAGO_COBRO_MODAL = (t: $TSMigrationFixMe) => {
  const columns = [
    // {
    //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //   render: (record: $TSFixMe) =>
    //     AntProTableResponsiveTemplate({
    //       title: record?.numero,
    //       actions: record?.filter,
    //       columns: COLUMNAS_FACTURAS_RECIBIDAS_RESPONSIVE(t, record),
    //       headerStyles: "tw-pt-[3px] !tw-pb-0",
    //     }),
    //   responsive: ["xs"],
    // },
    {
      title: t("crear.factura.addPagoCobro.numberTitle"),
      dataIndex: "identificador",
      key: "identificador",
      className: "text-base text-text",
      sorter: true,
      responsive: ["sm"],
    },
    {
      title: t("crear.factura.addPagoCobro.dateTitle"),
      dataIndex: "fecha",
      key: "fecha",
      className: "text-base text-text",
      sorter: true,
      responsive: ["sm"],
    },
    {
      title: t("crear.factura.addPagoCobro.desciptionTitle"),
      dataIndex: "descripcion",
      key: "descripcion",
      className: "text-base text-text",
      sorter: true,
      responsive: ["sm"],
    },
    {
      title: t("crear.factura.addPagoCobro.importTitle"),
      dataIndex: "importe",
      key: "importe",
      align: "right",
      className: "text-base text-text",
      sorter: true,
      responsive: ["sm"],
      renderText: (rowData: $TSMigrationFixMe) => formatCurrency(rowData),
    },
  ]
  return columns
}

export const documentoPendienteValidarFetch = async (
  docType: TipoDocumentoEnumType,
  documentoID: string
) => {
  const fetchFn = () => {
    switch (docType) {
      case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
        return getPresupuestoDocumentoPendienteValidacionDocumentoPendienteValidacion(
          documentoID
        )
      case TIPO_DOCUMENTO_ENUM.ALBARAN:
        return getAlbaranesDocumentoPendienteValidacionDocumentoPendienteValidacion(
          documentoID
        )
      case TIPO_DOCUMENTO_ENUM.PEDIDO:
        return getPedidoDocumentoPendienteValidacionDocumentoPendienteValidacion(
          documentoID
        )
      case TIPO_DOCUMENTO_ENUM.FACTURA: {
        return getFacturasDocumentoPendienteValidacionDocumentoPendienteValidacion(
          documentoID
        )
      }
      default:
        return Promise.reject(new Error("Tipo de documento no soportado"))
    }
  }

  const data = await fetchFn()

  return data
}

export const downloadDocumentoFetch = async (
  docType: TipoDocumentoEnumType,
  documentoID: string
) => {
  const fetchFn = () => {
    switch (docType) {
      case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
        return getPresupuestoPdfById(documentoID)
      case TIPO_DOCUMENTO_ENUM.ALBARAN:
        return getAlbaranPdfById(documentoID)
      case TIPO_DOCUMENTO_ENUM.PEDIDO:
        return getPedidoPdfById(documentoID)
      case TIPO_DOCUMENTO_ENUM.FACTURA:
        return getFacturaPdfById(documentoID)
      default:
        return Promise.reject(new Error("Tipo de documento no soportado"))
    }
  }

  const response = await fetchFn()

  if (response?.status === 204) {
    throw new Error("Documento vacío (204)")
  }

  return response.data
}

export const archivosAduntosDocumentoFetch = async (
  docType: TipoDocumentoEnumType,
  documentoID: string
) => {
  const fetchFn = () => {
    switch (docType) {
      case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
        return getPresupuestoFicherosAdjuntosId(documentoID)
      case TIPO_DOCUMENTO_ENUM.ALBARAN:
        return getAlbaranFicherosAdjuntosId(documentoID)
      case TIPO_DOCUMENTO_ENUM.PEDIDO:
        return getPedidoFicherosAdjuntosId(documentoID)
      case TIPO_DOCUMENTO_ENUM.FACTURA: {
        return getFacturaFicherosAdjuntosId(documentoID)
      }
      default:
        return Promise.reject(new Error("Tipo de documento no soportado"))
    }
  }

  const data = await fetchFn()

  return data
}

export const documentosAsociadosDocumentoFetch = async (
  docType: TipoDocumentoEnumType,
  documentoID: string
) => {
  const fetchFn = () => {
    switch (docType) {
      case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
        return getPresupuestoDocsAsociadosById(documentoID)
      case TIPO_DOCUMENTO_ENUM.ALBARAN:
        return getAlbaranDocsAsociadosById(documentoID)
      case TIPO_DOCUMENTO_ENUM.PEDIDO:
        return getPedidoDocsAsociadosById(documentoID)
      case TIPO_DOCUMENTO_ENUM.FACTURA: {
        return getFacturaDocsAsociadosById(documentoID)
      }
      default:
        return Promise.reject(new Error("Tipo de documento no soportado"))
    }
  }
  const data = await fetchFn()
  return data
}

export const eliminarArchivoDocumentoFetch = async (
  fileID: string,
  docType: TipoDocumentoEnumType,
  documentoID: string
) => {
  const fetchFn = () => {
    switch (docType) {
      case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
        return deletePresupuestoArichivoAdjunto(documentoID, fileID)
      case TIPO_DOCUMENTO_ENUM.ALBARAN:
        return deleteAlbaranArichivoAdjunto(documentoID, fileID)
      case TIPO_DOCUMENTO_ENUM.PEDIDO:
        return deletePedidoArichivoAdjunto(documentoID, fileID)
      case TIPO_DOCUMENTO_ENUM.FACTURA:
        return deleteFacturaArichivoAdjunto(documentoID, fileID)
      default:
        return Promise.reject(new Error("Tipo de documento no soportado"))
    }
  }

  const response = await fetchFn()
  return response
}

export const agregarArchivoAdjuntoDocumentoFetch = async (
  addArchivoData: FicheroCreationDtoProps,
  docType: TipoDocumentoEnumType,
  documentoID: string
) => {
  const fetchFn = () => {
    switch (docType) {
      case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
        return postPresupuestoAñadirArchivoAdjunto(documentoID, addArchivoData)
      case TIPO_DOCUMENTO_ENUM.ALBARAN:
        return postAlbaranAñadirArchivoAdjunto(documentoID, addArchivoData)
      case TIPO_DOCUMENTO_ENUM.PEDIDO:
        return postPedidoAñadirArchivoAdjunto(documentoID, addArchivoData)
      case TIPO_DOCUMENTO_ENUM.FACTURA:
        return postFacturaAñadirArchivoAdjunto(documentoID, addArchivoData)
      default:
        return Promise.reject(new Error("Tipo de documento no soportado"))
    }
  }

  const response = await fetchFn()
  return response
}
